module.exports = "<p class=\"info info--error\" translate>auth.resetPassword.invalidHash</p>\n<p class=\"info-text\" [routerLink]=\"['/recover-password']\" [innerHTML]=\"'auth.resetPassword.resign' | translate\"></p>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/auth/reset-password/reset-password-invalid/reset-password-invalid.component.html
// module id = ../../../../../src/app/auth/reset-password/reset-password-invalid/reset-password-invalid.component.html
// module chunks = main